import React from 'react';
import PageBase from '../components/PageBase';
// import { Table, Thead, Tbody, Tr, Td, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import {Helmet} from "react-helmet";

const Egutegia = () => {

/*
  const styles = {
    filas: {
      textAlign: 'left'
    }
  };
*/

  return (
    <PageBase title="Gipuzkoko eskolarteko frogen egutegia"
              navigation="Oñatiko Duatloi Txikia / Gipuzkoko eskolarteko frogen egutegia">

      <Helmet>
          <title>Oñatiko Dutloi Txikia Egutegia</title>
          <meta name="description" content="Gipuzkoako beste dautloi eta triatloi txiki batzuk" />
          <meta property="og:title" content="Oñatiko Dutloi Txikia Egutegia" />
          <meta property="og:description" content="Gipuzkoako beste dautloi eta triatloi txiki batzuk" />
          <meta property="og:url" content="http://duatloitxikia.oinatikoduatloia.com/egutegia" />
          <meta property="og:image" content="http://duatloitxikia.oinatikoduatloia.com/kartela-duatloi-txikia.png" />
      </Helmet>
        

<p>Datak oraindik zehaztear</p>
{

  /*
<Table>
  <Thead>
    <Tr>
      <Th style={styles.filas}>Antolatzailea</Th>
      <Th style={styles.filas}>Kirola</Th>
      <Th style={styles.filas}>Data</Th>
      <Th style={styles.filas}>Herria</Th>
    </Tr>
  </Thead>

  <Tbody>
    <Tr>
      <Td>Aloña Mendi K.E.</Td>
      <Td>Duatloia</Td>
      <Td>Matxoak 17</Td>
      <Td>Oñati</Td>
    </Tr>

    <Tr>
      <Td>Urola</Td>
      <Td>Duatloia</Td>
      <Td>Apirila?</Td>
      <Td>Zumarraga/Urretxu</Td>
    </Tr>

    <Tr>
      <Td>Oarsotri</Td>
      <Td>Triatloia</Td>
      <Td>Maiatzeko lehen hamabostaldian</Td>
      <Td>Orereta</Td>
    </Tr>

    <Tr>
      <Td>Antzar</Td>
      <Td>Triatloia</Td>
      <Td>Ekainak 9</Td>
      <Td>Lazkao</Td>
    </Tr>

    <Tr>
      <Td>Zumaia</Td>
      <Td>Duatloia</Td>
      <Td>Ekainak 16</Td>
      <Td>Zumaia</Td>
    </Tr>

    <Tr>
      <Td>Antxintxika</Td>
      <Td>Triatloia</Td>
      <Td>Ekainak 23</Td>
      <Td>Bergara</Td>
    </Tr>

    <Tr>
      <Td>Nik Tri</Td>
      <Td>Triatloia</Td>
      <Td>Irailak 07</Td>
      <Td>Aia/Orio</Td>
    </Tr>

    <Tr>
      <Td>Antzar</Td>
      <Td>Duatloi krossa</Td>
      <Td>Irailak 29</Td>
      <Td>Lazkao</Td>
    </Tr>

    <Tr>
      <Td>Nik Tri</Td>
      <Td>Akuatloia</Td>
      <Td>Iraila</Td>
      <Td>Donostia</Td>
    </Tr>
    <Tr>
      <Td>Eibar</Td>
      <Td>Duatloia</Td>
      <Td>Azaro amaieran</Td>
      <Td>Eibar</Td>
    </Tr>
    <Tr>
      <Td>Talaixa</Td>
      <Td>Duatloi edo Triatloi</Td>
      <Td>Mutrikuko triatloiaren egunean</Td>
      <Td>Mutriku</Td>
    </Tr>
  </Tbody>
</Table>

  */
}





    </PageBase>
  );
};

export default Egutegia;



/** WEBPACK FOOTER **
 ** ./src/containers/Egutegia.js
 **/